import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  formatReferenceDateForApi,
  parseReferenceDateInput,
} from "./isfSiteSetupService";

export default function IsfReferenceDatePicker({
  value,
  onChange,
  disabled = false,
  placeholder = "dd-mm-yyyy",
  inputClassName = "form-control form-control-sm",
}) {
  return (
    <DatePicker
      selected={parseReferenceDateInput(value)}
      onChange={(date) => onChange?.(formatReferenceDateForApi(date))}
      className={inputClassName}
      dateFormat="dd-MM-yyyy"
      placeholderText={placeholder}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      disabled={disabled}
      isClearable={false}
    />
  );
}
